import httpClient from './_httpClient';
import httpClientWithoutToken from "./_httpClientWithoutToken";
const END_POINT = '/translate';

const getDictionaries = () => httpClientWithoutToken.get(END_POINT +"/dictionaries");
const getLanguageDictionaries = (lang) => httpClient.get(END_POINT +"/dictionaries/"+lang);
const updateConfigScope = (scopeId, data) => httpClient.put('/scopes/' + scopeId + END_POINT +"/updateScope", data);
const updateDictionary = (fileName, data) => httpClient.put(END_POINT +"/update/"+fileName, data);

export {
  getDictionaries,
  updateConfigScope,
  updateDictionary,
  getLanguageDictionaries
}
